// ContextMenu.js
import React, { useEffect, useRef } from "react";

const ContextMenu = ({ x, y, isVisible, options, onClose }) => {
  const menuRef = useRef(null);

  useEffect(() => {
    let clickTimeout;
    
    const handleClickOutside = (event) => {
      if (menuRef.current && !menuRef.current.contains(event.target)) {
        // Clear any existing timeout
        if (clickTimeout) {
          clearTimeout(clickTimeout);
        }
        
        // Only close on left-click, not right-click
        if (event.button === 0) {
          // Small delay to prevent immediate closing when right-clicking
          clickTimeout = setTimeout(() => {
            onClose && onClose();
          }, 150);
        }
      }
    };

    const handleScroll = () => {
      onClose && onClose();
    };

    const handleContextMenu = (event) => {
      // Prevent default browser context menu when our menu is visible
      event.preventDefault();
      // Close our menu when right-clicking anywhere else
      onClose && onClose();
    };

    if (isVisible) {
      // Add event listeners when menu is visible
      document.addEventListener('mousedown', handleClickOutside);
      document.addEventListener('scroll', handleScroll, true);
      document.addEventListener('contextmenu', handleContextMenu);
      
      return () => {
        // Cleanup event listeners and timeout
        document.removeEventListener('mousedown', handleClickOutside);
        document.removeEventListener('scroll', handleScroll, true);
        document.removeEventListener('contextmenu', handleContextMenu);
        if (clickTimeout) {
          clearTimeout(clickTimeout);
        }
      };
    }
  }, [isVisible, onClose]);

  if (!isVisible || !options || options.length === 0) {
    return null;
  }

  return (
    <ul
      ref={menuRef}
     className="fixed bg-zinc-950 shadow-md shadow-black rounded-lg border border-dashed border-zinc-700"
      style={{ top: y + "px", left: x + "px", zIndex: 9999 }}
    >
      {options.map((option, index) => (
        <li
          key={index}
          className="px-4 py-2 hover:bg-zinc-900 text-sm rounded-lg cursor-pointer"
          onClick={() => {
            option.onClick && option.onClick();
            onClose && onClose();
          }}
        >
          {option.label}
        </li>
      ))}
    </ul>
  );
};

export default ContextMenu;
